(() => {
  const drawer = document.getElementById('GOSProductsDrawer');
  if (!drawer) return;

  const screens = [...drawer.querySelectorAll('[data-gos-screen]')];
  const azList = drawer.querySelector('[data-gos-az-list]');
  const alphabetWrap = drawer.querySelector('[data-gos-alphabet]');
  const searchInput = drawer.querySelector('[data-gos-az-search]');
  let productsPromise;
  let products = [];
  let lastTrigger = null;

  const iconPaths = {
    general:'<circle cx="12" cy="12" r="8"/><path d="M12 8v8M8 12h8"/>',
    heart:'<path d="M12 20s-7-4.5-7-10a4 4 0 017-2.5A4 4 0 0119 10c0 5.5-7 10-7 10z"/>',
    brain:'<path d="M9 5a3 3 0 00-3 3v1a3 3 0 000 6v1a3 3 0 003 3M15 5a3 3 0 013 3v1a3 3 0 010 6v1a3 3 0 01-3 3M12 4v16M9 8h3M12 12h3M9 16h3"/>',
    sleep:'<path d="M18 15.5A7 7 0 018.5 6a7 7 0 109.5 9.5z"/>',
    mood:'<circle cx="12" cy="12" r="8"/><path d="M9 10h.01M15 10h.01M9 15c1.5 1.2 4.5 1.2 6 0"/>',
    gut:'<path d="M8 4v5c0 2 1 3 3 3h2c2 0 3 1 3 3s-1.5 4-4 4-4-1.5-4-4M16 4v4"/>',
    immune:'<path d="M12 3l7 3v5c0 4.6-2.7 7.8-7 10-4.3-2.2-7-5.4-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/>',
    respiratory:'<path d="M11 11V5M13 11V5M11 10c-3 0-5 2.5-5 6v3c3 0 5-1.5 5-4M13 10c3 0 5 2.5 5 6v3c-3 0-5-1.5-5-4"/>',
    bone:'<path d="M8 9a2.5 2.5 0 11-3.5-3.5A2.5 2.5 0 118 2l8 8a2.5 2.5 0 013.5 3.5A2.5 2.5 0 1116 17l-8-8z"/>',
    joint:'<circle cx="8" cy="8" r="3"/><circle cx="16" cy="16" r="3"/><path d="M10 10l4 4M6 14l4-4M14 6l-4 4"/>',
    energy:'<path d="M13 2L5 14h6l-1 8 9-13h-6V2z"/>',
    men:'<circle cx="11" cy="9" r="4"/><path d="M4 21c.8-4 3.2-6 7-6s6.2 2 7 6M16 4h5v5M20.5 4.5l-4 4"/>',
    women:'<circle cx="12" cy="8" r="4"/><path d="M12 12v9M8 17h8"/>',
    weight:'<path d="M5 7h14l-1 13H6L5 7z"/><path d="M9 7a3 3 0 016 0M12 11l2 3"/>',
    eye:'<path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6z"/><circle cx="12" cy="12" r="2.5"/>',
    beauty:'<path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3zM18 15l.9 2.1L21 18l-2.1.9L18 21l-.9-2.1L15 18l2.1-.9L18 15z"/>',
    aging:'<path d="M12 21c0-7 3-12 8-16-7 0-13 4-16 10 2 0 5 0 8-2"/><path d="M7 17c3-4 6-6 10-8"/>',
    liver:'<path d="M5 7c5-3 12-2 14 2 1.5 3-1 7-5 7-3 0-4-2-6-2-2 0-3 1-4 2 0-4-1-7 1-9z"/>',
    kidney:'<path d="M9 5C5 5 4 9 5 13c1 4 4 6 6 4 1-1 1-3 1-5 0-4-1-7-3-7zM15 5c4 0 5 4 4 8-1 4-4 6-6 4-1-1-1-3-1-5 0-4 1-7 3-7z"/>',
    metabolic:'<path d="M7 7h4V3M17 17h-4v4"/><path d="M18 9a7 7 0 00-11-4L5 7M6 15a7 7 0 0011 4l2-2"/>'
  };

  drawer.querySelectorAll('[data-icon]').forEach(el => {
    const key = el.dataset.icon;
    el.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true">${iconPaths[key] || iconPaths.general}</svg>`;
  });

  const normalize = s => (s || '').toLowerCase().replace(/[’']/g, "'").replace(/\s+/g, ' ').trim();
  const productTags = p => Array.isArray(p.tags) ? p.tags.map(normalize) : String(p.tags || '').split(',').map(normalize);
  const isRefillProduct = p => /\brefill\b/i.test(p.title || '') || productTags(p).includes('refill');
  const isSampleProduct = p => /\bsample\b/i.test(p.title || '') || productTags(p).includes('sample');
  const displayProductTitle = p => {
    if (p._gosBaseTitle) return p._gosBaseTitle;
    const title = String(p.title || '').trim();
    return title
      .replace(/\s*,?\s*refill\s*(?:\([^)]*\))?\s*$/i, '')
      .replace(/\s*[-–—,]?\s*(?:sample|sample size)\s*(?:\([^)]*\))?\s*$/i, '')
      .replace(/\s*\((?:sample|sample size)\)\s*$/i, '')
      .replace(/\s*,\s*$/, '')
      .trim();
  };
  const productFormat = p => isRefillProduct(p) ? 'Refill' : isSampleProduct(p) ? 'Sample' : 'Bottle';


  function showScreen(name, direction = 'forward') {
    const target = screens.find(s => s.dataset.gosScreen === name);
    if (!target) return;
    screens.forEach(s => {
      s.classList.remove('is-active','is-behind');
      if (direction === 'forward' && s !== target) s.classList.add('is-behind');
    });
    target.classList.remove('is-behind');
    target.classList.add('is-active');
    if (name === 'az') ensureProducts().then(renderAZ);
  }

  function openDrawer(trigger, startScreen = 'main') {
    lastTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.querySelectorAll('[data-gos-products-trigger], .gos-products-trigger').forEach(el => el.setAttribute('aria-expanded','true'));
    document.body.classList.add('gos-nav-open');
    const targetScreen = screens.some(s => s.dataset.gosScreen === startScreen) ? startScreen : 'main';
    showScreen(targetScreen, targetScreen === 'main' ? 'back' : 'forward');
    setTimeout(() => {
      if (targetScreen === 'az') searchInput?.focus();
      else if (targetScreen === 'benefits') drawer.querySelector('.gos-products-nav__benefit, [data-gos-open-screen="main"]')?.focus();
      else if (targetScreen === 'ingredients') drawer.querySelector('[data-gos-ingredient], [data-gos-open-screen="main"]')?.focus();
      else drawer.querySelector('[data-gos-open-screen="az"]')?.focus();
    }, 80);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.querySelectorAll('[data-gos-products-trigger], .gos-products-trigger').forEach(el => el.setAttribute('aria-expanded','false'));
    document.body.classList.remove('gos-nav-open');
    lastTrigger?.focus?.();
  }

  // Public fallback API for header controls. The delegated click handler remains
  // the primary path; this guarantees an in-place Shop button can still open
  // the drawer if another theme script interferes with event delegation.
  window.GOSProductsNav = {
    open: (trigger, startScreen = 'main') => openDrawer(trigger, startScreen),
    close: closeDrawer,
    show: (screen) => showScreen(screen)
  };

  drawer.querySelectorAll('[data-gos-close]').forEach(el => el.addEventListener('click', closeDrawer));
  drawer.querySelectorAll('[data-gos-open-screen]').forEach(el => el.addEventListener('click', () => {
    const target = el.dataset.gosOpenScreen;
    const back = target === 'main' || target === 'benefits';
    showScreen(target, back ? 'back' : 'forward');
  }));


  // One global discovery controller for every A–Z / By Benefit entry point.
  // Uses capture phase so legacy theme click handlers cannot swallow the action.
  function linkedBenefitForKey(key) {
    if (!key) return null;
    const normalizedKey = String(key).trim().toLowerCase();
    const icons = [...drawer.querySelectorAll('.gos-products-nav__benefit [data-icon]')];
    const icon = icons.find(el => String(el.dataset.icon || '').trim().toLowerCase() === normalizedKey);
    return icon?.closest('a.gos-products-nav__benefit') || null;
  }

  function hydrateBenefitLinks(root = document) {
    root.querySelectorAll('[data-gos-benefit-key]').forEach(card => {
      const linkedBenefit = linkedBenefitForKey(card.dataset.gosBenefitKey);
      if (linkedBenefit?.href) {
        card.href = linkedBenefit.href;
        card.dataset.gosCollectionLinked = 'true';
        card.removeAttribute('aria-disabled');
      } else {
        card.href = '#';
        card.dataset.gosCollectionLinked = 'false';
        card.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function handleDiscoveryClick(event) {
    const benefitCard = event.target.closest('[data-gos-benefit-key]');
    if (benefitCard) {
      const linkedBenefit = linkedBenefitForKey(benefitCard.dataset.gosBenefitKey);
      if (linkedBenefit?.href) {
        // Use the collection assigned in Header settings. This is a normal page
        // navigation, not another product-list drawer.
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(linkedBenefit.href);
        return;
      }
      // If the merchant has not linked this benefit yet, fall back to the full
      // By Benefit drawer so the click never feels broken.
      event.preventDefault();
      event.stopPropagation();
      openDrawer(benefitCard, 'benefits');
      return;
    }

    const trigger = event.target.closest('[data-gos-products-trigger], .gos-products-trigger');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openDrawer(trigger, trigger.dataset.gosStartScreen || 'main');
  }

  document.addEventListener('click', handleDiscoveryClick, true);
  hydrateBenefitLinks();
  document.addEventListener('shopify:section:load', event => hydrateBenefitLinks(event.target || document));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  const PRODUCT_CACHE_KEY = 'gos-az-products-v3';
  const PRODUCT_CACHE_TTL = 30 * 60 * 1000; // 30 minutes

  function readProductCache() {
    try {
      const cached = JSON.parse(sessionStorage.getItem(PRODUCT_CACHE_KEY) || 'null');
      if (!cached || !Array.isArray(cached.products)) return null;
      if ((Date.now() - Number(cached.savedAt || 0)) > PRODUCT_CACHE_TTL) {
        sessionStorage.removeItem(PRODUCT_CACHE_KEY);
        return null;
      }
      return cached.products;
    } catch (_) {
      return null;
    }
  }

  function writeProductCache(list) {
    try {
      sessionStorage.setItem(PRODUCT_CACHE_KEY, JSON.stringify({ savedAt: Date.now(), products: list }));
    } catch (_) {}
  }

  async function fetchProductPage(page) {
    const response = await fetch(`/products.json?limit=250&page=${page}`, {
      credentials:'same-origin',
      cache:'force-cache',
      priority:'low'
    });
    if (!response.ok) return [];
    const data = await response.json();
    return data.products || [];
  }

  async function fetchProducts() {
    // Green Organic currently fits in two 250-product pages. Fetching the first
    // two pages in parallel removes the old page-1 -> page-2 waterfall. If the
    // second page ever fills up, continue with later pages only then.
    const [first, second] = await Promise.all([fetchProductPage(1), fetchProductPage(2)]);
    const all = [...first, ...second];

    if (second.length >= 250) {
      for (let page = 3; page <= 6; page++) {
        const batch = await fetchProductPage(page);
        all.push(...batch);
        if (batch.length < 250) break;
      }
    }

    const seen = new Set();
    return all.filter(p => {
      if (!p || !p.handle || seen.has(p.handle)) return false;
      seen.add(p.handle);
      return true;
    });
  }

  function ensureProducts() {
    if (products.length) return Promise.resolve(products);
    if (!productsPromise) {
      const cached = readProductCache();
      if (cached?.length) {
        products = cached;
        productsPromise = Promise.resolve(cached);
      } else {
        productsPromise = fetchProducts().then(list => {
          products = list;
          writeProductCache(list);
          return list;
        }).catch(() => {
          products = [];
          return [];
        });
      }
    }
    return productsPromise;
  }

  function warmAZProducts() {
    ensureProducts().then(() => {
      if (drawer.querySelector('[data-gos-screen="az"]')?.classList.contains('is-active')) renderAZ();
    });
  }

  // Start loading quietly after the page's critical work. By the time most
  // shoppers open Shop -> A-Z, the directory is already in memory.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(warmAZProducts, { timeout: 1400 });
  } else {
    setTimeout(warmAZProducts, 500);
  }

  // Also warm immediately when a shopper shows intent to use Shop/A-Z.
  document.addEventListener('pointerover', event => {
    if (event.target.closest('[data-gos-products-trigger], .gos-products-trigger, [data-gos-open-screen="az"]')) warmAZProducts();
  }, { passive: true });
  document.addEventListener('focusin', event => {
    if (event.target.closest('[data-gos-products-trigger], .gos-products-trigger, [data-gos-open-screen="az"]')) warmAZProducts();
  });

  function groupAZ(filter = '') {
    const query = normalize(filter);
    const groups = {};
    const formulas = new Map();
    products.forEach(p => {
      const title = displayProductTitle(p);
      const key = normalize(title).replace(/[^a-z0-9]+/g, ' ').trim();
      if (!key) return;
      if (!formulas.has(key)) formulas.set(key, { title, products: [], formats: new Set(), representative: p });
      const formula = formulas.get(key);
      formula.products.push(p);
      formula.formats.add(productFormat(p));
      if (!isRefillProduct(p) && !isSampleProduct(p)) formula.representative = p;
    });
    formulas.forEach(formula => {
      const haystack = normalize(formula.products.map(p => [p.title,p.product_type,productFormat(p),Array.isArray(p.tags) ? p.tags.join(' ') : p.tags].join(' ')).join(' '));
      if (query && !haystack.includes(query) && !normalize(formula.title).includes(query)) return;
      const first = (formula.title || '#').trim().charAt(0).toUpperCase();
      const letter = /[A-Z]/.test(first) ? first : '#';
      groups[letter] ||= [];
      groups[letter].push({
        ...formula.representative,
        _gosBaseTitle: formula.title,
        _gosFormats: [...formula.formats].sort((a,b) => ['Bottle','Refill','Sample'].indexOf(a) - ['Bottle','Refill','Sample'].indexOf(b))
      });
    });
    Object.values(groups).forEach(arr => arr.sort((a,b) => displayProductTitle(a).localeCompare(displayProductTitle(b))));
    return groups;
  }

  function renderAlphabet(groups) {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    alphabetWrap.innerHTML = letters.map(letter => `<button type="button" class="gos-products-nav__letter" data-gos-letter="${letter}" ${groups[letter] ? '' : 'disabled'}>${letter}</button>`).join('');
    alphabetWrap.querySelectorAll('[data-gos-letter]').forEach(btn => btn.addEventListener('click', () => {
      azList.querySelector(`[data-letter-block="${btn.dataset.gosLetter}"]`)?.scrollIntoView({behavior:'smooth',block:'start'});
    }));
  }

  function renderAZ() {
    const groups = groupAZ(searchInput?.value || '');
    renderAlphabet(groups);
    const letters = Object.keys(groups).sort();
    if (!letters.length) {
      azList.innerHTML = '<div class="gos-products-nav__empty">No products found.</div>';
      return;
    }
    azList.innerHTML = letters.map(letter => `<section class="gos-products-nav__letter-block" data-letter-block="${letter}"><h3>${letter}</h3>${groups[letter].map(p => {
      const formats = p._gosFormats || [productFormat(p)];
      const label = formats.length > 1 ? formats.length + ' formats' : formats[0];
      return `<a class="gos-products-nav__product-link" href="/products/${p.handle}"><span class="gos-products-nav__product-name">${escapeHTML(displayProductTitle(p))}</span><span class="gos-products-nav__product-format gos-products-nav__product-format--bottle">${escapeHTML(label)}</span></a>`;
    }).join('')}</section>`).join('');
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  }

  searchInput?.addEventListener('input', renderAZ);

  function textOf(el) { return normalize(el.textContent || '').replace(/[›⌄⌃]/g,'').trim(); }

  function setShopLabel(el) {
    const labelNode = el.querySelector('span') || el;
    // Remove native caret/arrow icons so the old Categories dropdown no longer looks active.
    el.querySelectorAll('svg').forEach(svg => svg.remove());
    const textNodes = [...labelNode.childNodes].filter(n => n.nodeType === Node.TEXT_NODE);
    if (textNodes.length) {
      textNodes.forEach((n, i) => n.textContent = i === 0 ? 'Shop' : '');
    } else {
      labelNode.textContent = 'Shop';
    }
    el.setAttribute('aria-label', 'Open Shop menu');
  }

  function disableNativeSubmenu(el) {
    const details = el.closest('details');
    if (!details) return;
    details.removeAttribute('open');
    details.classList.add('gos-shop-details');
    // Keep the top-level trigger, but suppress the old Categories submenu entirely.
    [...details.children].forEach(child => {
      if (child !== el && child.tagName !== 'SUMMARY') child.setAttribute('hidden', 'hidden');
    });
  }

  function wireExistingNavigation() {
    const candidates = [...document.querySelectorAll('header a.header__menu-item, header summary.header__menu-item, .menu-drawer__navigation a.menu-drawer__menu-item, .menu-drawer__navigation summary.menu-drawer__menu-item')];
    let wired = 0;
    candidates.forEach(el => {
      const txt = textOf(el);
      if (txt === 'categories' || txt === 'products' || txt === 'shop') {
        if (el.dataset.gosShopWired === 'true') return;
        el.dataset.gosShopWired = 'true';
        el.classList.add('gos-products-trigger');
        setShopLabel(el);
        disableNativeSubmenu(el);
        el.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          disableNativeSubmenu(el);
          document.querySelector('#Details-menu-drawer-container')?.removeAttribute('open');
          openDrawer(el);
        }, true);
        wired++;
      }
    });

    if (!wired) {
      document.querySelectorAll('.header__inline-menu ul.list-menu--inline').forEach(ul => {
        if (ul.querySelector('.gos-products-trigger')) return;
        const li = document.createElement('li');
        li.className = 'gos-shop-menu-item';
        li.innerHTML = '<button type="button" class="header__menu-item list-menu__item link link--text focus-inset gos-products-trigger"><span>Shop</span></button>';
        li.querySelector('button').addEventListener('click', e => openDrawer(e.currentTarget));
        ul.prepend(li);
      });
      const mobile = document.querySelector('.menu-drawer__navigation .menu-drawer__menu');
      if (mobile && !mobile.querySelector('.gos-products-trigger')) {
        const li = document.createElement('li');
        li.className = 'gos-shop-menu-item';
        li.innerHTML = '<button type="button" class="menu-drawer__menu-item list-menu__item link link--text focus-inset gos-products-trigger">Shop <span class="gos-products-nav__chevron">›</span></button>';
        li.querySelector('button').addEventListener('click', e => {
          document.querySelector('#Details-menu-drawer-container')?.removeAttribute('open');
          openDrawer(e.currentTarget);
        });
        mobile.prepend(li);
      }
    }
  }

  wireExistingNavigation();
  document.addEventListener('shopify:section:load', wireExistingNavigation);
})();
